import { createRouter, createWebHistory } from 'vue-router';

import Home from '../pages/Home.vue';
import MyProfile from '../pages/MyProfile.vue';
import PersonalInfo from '../pages/PersonalInfo.vue';
import MyProjects from '../pages/MyProjects.vue';
import UploadFile from '../pages/UploadFile.vue';
import MakeSubContract from '../pages/MakeSubContract.vue';
import MakeClientContract from '../pages/MakeClientContract.vue';
import EditSubContract from '../pages/EditSubContract.vue';
import EditClientContract from '../pages/EditClientContract.vue';
import Signature from '../pages/Signature.vue';

import Subscription from '../pages/Subscription.vue';

import Success from '../pages/Success.vue';
import Cancel from '../pages/Cancel.vue';
import Settings from '../pages/Settings.vue';
import ContractTemplate from '../pages/ContractTemplate.vue';
import ContractTemplateDetail from '../pages/ContractTemplateDetail.vue';

import Login from '../pages/Login.vue';
import Project from '../pages/Project.vue';
import Blog from '../pages/Blog.vue';
import BlogDetail from '../pages/BlogDetail.vue';
import InnerBlog from '../pages/InnerBlog.vue';
import Eula from '../pages/Eula.vue';
import MyContacts from '../pages/MyClients.vue';

import MakeClientContractDemo from '../pages/MakeClientContract2.vue';
import HowToUse from '../pages/HowToUse.vue';

import HowWeWork from '../pages/HowWeWork.vue';

const routes = [
    { path: '/', component: Home },
    { path: '/MyProfile/:tabIdx', component: MyProfile },
    { path: '/PersonalInfo/:tabIdx', component: PersonalInfo },
    { path: '/MyProjects', component: MyProjects },
    { path: '/UploadFile', component: UploadFile },
    { path: '/MakeSubContract/:projectid/:subcontractorid', component: MakeSubContract },
    { path: '/MakeClientContract/:projectid', component: MakeClientContract },
    { path: '/EditSubContract/:contractid', component: EditSubContract },
    { path: '/EditClientContract/:contractid', component: EditClientContract },
    { path: '/Signature/', component: Signature },
    { path: '/Subscription/', component: Subscription },

    { path: '/Settings', component: Settings },
    { path: '/ContractTemplate', component: ContractTemplate },
    { path: '/ContractTemplateDetail', component: ContractTemplateDetail },
    { path: '/Success/:sessionid', component: Success },
    { path: '/Cancel/', component: Cancel },

    { path: '/Login', component: Login },
    { path: '/Project/:id?', component: Project },
    { path: '/Blog', component: Blog },
    { path: '/Blog/:slug', component: BlogDetail, props: true },
    { path: '/Eula', component: Eula },
    { path: '/MyContacts', component: MyContacts },
    { path: '/HowToUse', component: HowToUse },
    { path: '/HowWeWork', component: HowWeWork },

    { path: '/MakeClientContractDemo/:projectid', component: MakeClientContractDemo },

    { path: '/InnerBlog/:id?', component: InnerBlog },
]


const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        return { top: 0 };
      }
})

export default router